import {setUpSentryLoggingService} from './sentry';

export function setUpLoggingService(cfg) {
    setUpSentryLoggingService(cfg);
}
